import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { GlobalMachineContext } from "../../../study-plans/pages/StudyPlansInit/StudyPlansInit"

export const useRedirectUrl = () => {
  const history = useHistory()

  const { redirectUrl, externalRedirectUrl, isOldNav } =
    GlobalMachineContext.useSelector(state => ({
      redirectUrl: state.context.redirectUrl,
      externalRedirectUrl: state.context.externalRedirectUrl,
      isOldNav: state.context.isOldNav
    }))

  const { send } = GlobalMachineContext.useActorRef()

  // Handle externalRedirectUrl with priority
  useEffect(() => {
    if (!externalRedirectUrl) return

    const currentLocation = history.location.pathname

    if (externalRedirectUrl.path !== currentLocation) {
      // Perform navigation
      if (isOldNav) {
        // Old nav: Just push the path
        history[externalRedirectUrl.action](externalRedirectUrl.path)
      } else {
        // New nav: Preserve query params (filters)
        const fullPath = `${externalRedirectUrl.path}${history.location.search}`
        history[externalRedirectUrl.action](fullPath)
      }
    }

    send({ type: "CLEAR_EXTERNAL_REDIRECT_URL" })
  }, [externalRedirectUrl, isOldNav, history])

  // Handle normal redirectUrl
  useEffect(() => {
    if (!redirectUrl || externalRedirectUrl) return // Skip if external redirect is active

    const currentLocation = history.location.pathname

    if (redirectUrl.path !== currentLocation) {
      // Perform navigation
      if (isOldNav) {
        // Old nav: Just push the path
        history[redirectUrl.action](redirectUrl.path)
      } else {
        // New nav: Preserve query params (filters)
        const fullPath = `${redirectUrl.path}${history.location.search}`
        history[redirectUrl.action](fullPath)
      }

      send({ type: "CLEAR_REDIRECT_URL" })
    } else {
      // Already at the target location
      send({ type: "CLEAR_REDIRECT_URL" })
    }
  }, [redirectUrl, externalRedirectUrl, isOldNav, history])
}
